import { SelectItem } from "../selectItem";
import React, { useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./styles.css";
import { useTranslations } from "adapters/i18n";

export const SelectTypeOfCollection = ({ setFiltro, filtroColetas }) => {
  const { t } = useTranslations();
  const filtrosColetas = [
    "todos",
    "dentro_da_area",
    "fora_da_area",
    "sem_geolocalizacao",
  ];

  const filtrosMensagens = {
    todos: t("common:all-male"),
    dentro_da_area: t("statusIndicator:collect-inside-area"),
    fora_da_area: t("statusIndicator:collect-outside-area"),
    sem_geolocalizacao: t("statusIndicator:without-localization"),
  };

  const [isActive, setIsActive] = useState(false);
  const [selectedValue, setSelectedValue] = useState(filtrosMensagens.todos);

  const handleClick = () => {
    setIsActive(!isActive);
  };

  useEffect(() => {
    setSelectedValue(filtrosMensagens[filtroColetas]);
  }, [filtroColetas]);

  const handleOptionClick = (name) => {
    setIsActive(false);
    setFiltro(name);
  };

  return (
    <div className={`custom-select ${isActive ? "active" : ""}`}>
      <button className="select-button" onClick={handleClick}>
        <span className="selected-value">{selectedValue}</span>
        <ExpandMoreIcon className="arrow"></ExpandMoreIcon>
      </button>
      <ul className="select-dropdown" id="select-dropdown">
        {filtrosColetas.map((name) => (
          <SelectItem
            id={name}
            key={name}
            onClick={() => handleOptionClick(name)}
          >
            {filtrosMensagens[name]}
          </SelectItem>
        ))}
      </ul>
    </div>
  );
};
